export const objectToQueryParamsString = (obj: Record<string, string | undefined | null>) =>
  Object.entries(obj).reduce((acc, [key, val]) => {
    if (!val) {
      return acc;
    }
    return `${acc}${acc.length ? '&' : ''}${key}=${val}`;
  }, '');
